import config from 'config'
import {
  Login,
  Logout,
  LogoutInactive,
  Forbidden
} from 'containers/pages'

import { get } from 'lodash'
import React from 'react'
import { BlankMain } from '../components/masters'

const publicPath = config.publicPath

const routes = [
  {
    path: `${publicPath}/login`,
    exact: true,
    component: props => (
      <Login
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/login/:loginId`,
    exact: true,
    component: props => (
      <Login
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/logout`,
    exact: true,
    component: props => (
      <Logout
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/logout-inactive`,
    exact: true,
    component: props => (
      <LogoutInactive
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/forbidden`,
    exact: true,
    component: props => (
        <BlankMain params={get(props, 'match.params', {})} {...props}>
          <Forbidden
              params={get(props, 'match.params', {})}
              {...props}
          />
        </BlankMain>
    ),
    routes: []
  }
]

export default routes
